import Vue from "vue";
import VueRouter from "vue-router";
import { title } from "@/config";

Vue.use(VueRouter);

// 引入页面组件
import Home from "../views/Home";
import SongWorksRegister from "../views/SongWorks/Register";
import SongWorksList from "../views/SongWorks/List";
import AudioWorksRegister from "../views/AudioWorks/Register";
import AudioWorksList from "../views/AudioWorks/List";

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/song-works",
    component: () => import("../views/SongWorks"),
    children: [
      {
        path: "",
        redirect: "register",
      },
      {
        path: "register",
        name: "song-work.register",
        component: SongWorksRegister,
      },
      {
        path: "list",
        name: "song-work.list",
        component: SongWorksList,
      },
    ],
  },
  {
    path: "/audio-works",
    component: () => import("../views/AudioWorks"),
    children: [
      {
        path: "",
        redirect: "register",
      },
      {
        path: "register",
        name: "audio-work.register",
        component: AudioWorksRegister,
      },
      {
        path: "list",
        name: "audio-work.list",
        component: AudioWorksList,
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || title;
  next();
});

export default router;
